/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceRulesInterestedAction = typeof SequenceRulesInterestedAction[keyof typeof SequenceRulesInterestedAction];


export const SequenceRulesInterestedAction = {
  do_nothing: 'do_nothing',
  next_stage: 'next_stage',
  move_stage: 'move_stage',
} as const;
